<template>
  <div class="widget-card widget-actions">
    <v-card class="widget-card__card" height="100%">
      <v-card-title class="primary white--text widget-card__card-title">
        Акции
      </v-card-title>
      <v-card-text class="widget-card__card-text pt-3">
        <div v-if="actions && !actions.length">Список акций пуст</div>
        <div v-else>
          <ul class="list">
            <li class="item" v-for="(a, idx) in actions" :key="idx" @click="$router.push('/actions')">{{a.title}}</li>
          </ul>
        </div>
      </v-card-text>
      <v-card-actions class="pa-3 widget-card__card-actions widget-actions__actions" bottom>
        <v-btn color="default" to="/actions" class="btn">
          <font-awesome-icon icon="ruble-sign" class="mr-2 size-18"/>
          <span>Посмотреть акции</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['user'],
  computed: {
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    isPeriodOpen() { return this.$store.getters.isPeriodOpen; },
    loading() { return this.$store.state.loading; },
    actions() { return this.$store.state.sales.actions; },
  },
  methods: {
    CloseSales() { this.$store.dispatch('ShowError', 'Уважаемые участники, внесение продаж приостановлено, в связи с окончанием программы лояльности "Клуб Профессионалов"'); },
  },
  async mounted() {
    await this.$store.dispatch('sales/GetActionsList', { profile_id: this.user.profile_id });
  },
};
</script>

<style lang="scss">
.widget-actions {
  &__actions {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }
  .list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .item {
    margin-bottom: 8px;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
